module.exports = __webpack_public_path__ + "static/media/Miguel.9ce5d0c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/testimonials/Miguel.png
// module id = 1466
// module chunks = 0